import { ImagePicture } from 'approot/shared/images/images';
import { STATIC_ASSETS } from 'webclient.constants';

const CodeForSchoolsLogo = ({
  width,
  height,
}: {
  width: number;
  height?: number;
}) => (
  <ImagePicture
    lazyLoad={false}
    style={{ width, height }}
    avif={{ path: `${STATIC_ASSETS}/code-for-schools.avif` }}
    webp={{ path: `${STATIC_ASSETS}/code-for-schools.webp` }}
    png={{ path: `${STATIC_ASSETS}/code-for-schools.png` }}
  />
);

export default CodeForSchoolsLogo;
